import { render, staticRenderFns } from "./SponsoredUserLoans.vue?vue&type=template&id=2e9b6b28"
import script from "./SponsoredUserLoans.vue?vue&type=script&lang=js"
export * from "./SponsoredUserLoans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports